var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"seo"},[_vm._v(_vm._s(_vm.data['field_2']))]),_vm._v(" "),_c('youtube',{ref:"youtube",attrs:{"video-id":_vm.data['field_1'],"player-vars":{ rel: 0 },"resize":true},on:{"playing":_vm.playing}},[_c('img',{attrs:{"src":_vm.data['field_3']}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }